import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { loadTenantConfig } from "./config/tenantConfig";
import { initDatadog } from "./services/datadog";

loadTenantConfig().then(() => {
  initDatadog();
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById("root")
  );
});
